export default {
    list: state => state.categories,
    authStatus: state => state.status,

    
}
